<template>
  <ElButton :loading="loading" type="primary" @click="confirmRegeneration">
    {{ $t('APP.API_AGENTS.REGENERATE_TOKEN') }}
  </ElButton>
</template>

<script>
import { AppApiAgents } from '@/api/api';
import packageName from '@/mixins/packageName';

export default {
  name: 'AppApiAgentsRegenerateButton',
  mixins: [packageName],
  props: {
    apiAgentId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    confirmRegeneration() {
      return this.$confirm(
        this.$t('APP.API_AGENTS.ARE_YOU_SURE_TO_REGENERATE'),
        this.$t('APP.API_AGENTS.REGENERATE_TOKEN'),
        {
          confirmButtonText: this.$t('APP.API_AGENTS.REGENERATE_TOKEN'),
          cancelButtonText: this.$t('CANCEL'),
          cancelButtonClass: 'el-button--text is-plain',
          confirmButtonClass: 'el-button--warning',
          type: 'warning',
        },
      )
        .then(() => {
          this.regenerateToken();
        })
        .catch(() => {});
    },
    regenerateToken() {
      this.loading = true;

      return AppApiAgents.regenerateToken({
        packageName: this.packageName,
        apiAgentId: this.apiAgentId,
      })
        .then(({ apiAgent, message }) => {
          if (message) {
            this.$message.success(message);
          }
          this.$emit('regenerate', apiAgent);
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
